import React, { useState } from "react";
import "../styled.css";
// moment
import moment from "moment";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function ItemSelect(props) {
  const { data, deleteScheduleFunc } = props;
  const [confirm, setConfirm] = useState(false);

  return (
    <>
      {confirm && (
        <SweetAlert
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          title="Deseja excluir essa atividade da sua agenda?"
          onCancel={() => setConfirm(false)}
          onConfirm={() => deleteScheduleFunc(data) > setConfirm(false)}
        />
      )}

      <div className="div-card-item">
        <i className="bx bx-check-circle icon-save-list" />
        <div className="div-data-list">
          <a style={{ fontWeight: "bold" }}>
            {data.sala} - {moment(data.dataHoraInicio).utc().format("HH:mm")}
          </a>
          <a>{data.atividade}</a>
        </div>
        <i
          className="bx bx-trash icon-delete-list"
          onClick={() => setConfirm(true)}
        />
      </div>
    </>
  );
}
